import React, { useState } from "react"
import styled from "@emotion/styled"
import { useFeatureIsOn } from "@growthbook/growthbook-react"

import AlertBanner from "../ui/alert-banner"

import mercadoPagoLogo from "../../images/mercadopago-logo.svg"
import MercadoPagoPeruView from "../mercadopago/mercadopago-uruguay"

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 4rem;
`

const ContainerButton = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
`

const Box = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  box-sizing: border-box;
  box-shadow: 0px 15px 30px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  padding: 1rem 0;
  margin: 1rem 0 2rem;
  width: 217px;
  min-height: 100px;
  cursor: pointer;
`

const get_text_important = () => (
  <>
    <strong>IMPORTANTE:</strong> En algunos casos podrá existir un costo por procesamiento de hasta un 4.99%, el cual será descontado del monto depositado.
  </>
)

const PayOnlineUruguay = () => {
  const isMercadoPagoEnabled = useFeatureIsOn("payment-mercadopago-uruguay")
  const [selectProvider, setSelectProvider] = useState<"mercadopago" | null>(null)

  const onClickMercadoPago = () => {
    setSelectProvider("mercadopago")
  }

  const methodPayment = {
    "mercadopago": MercadoPagoPeruView,
  }

  let ProviderSelected: any = <></>

  if (selectProvider !== null) {
    ProviderSelected = methodPayment[selectProvider]
  }

  return (
    <Content>
      <ContainerButton>
        {selectProvider === null && (
          <>
            {isMercadoPagoEnabled && (
              <Box onClick={onClickMercadoPago}>
                <img src={mercadoPagoLogo} alt="Mercado Pago" style={{ width: "190px" }} />
              </Box>
            )}
          </>
        )}
        {selectProvider !== null && <ProviderSelected />}
      </ContainerButton>
      <AlertBanner> {get_text_important()} </AlertBanner>
    </Content>
  )
}

export default PayOnlineUruguay
